export function getRandomColor() {
  // 生成随机的红、绿、蓝分量
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);

  // 将分量组合成RGB颜色
  const color = `rgb(${r}, ${g}, ${b})`;

  return color;
}
